module.exports = __webpack_public_path__ + "static/media/rock3-01.09339643.svg";